module.exports = __webpack_public_path__ + "carousel6.fbaa8f63.jpg";